import React from 'react'
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '~/lib/ui/table'
import Pagination from './Pagination'
import { useCandidateActivity } from './CandidateActivitySection'
import { useFormatTime } from '~/hooks/useFormatTime'

const PAGE_SIZE = 50

const JobSearches = () => {
  const { candidateJobSearches } = useCandidateActivity()
  const [page, setPage] = React.useState(1)
  const total = candidateJobSearches?.length || 0

  // Paginate activities
  const paginated = React.useMemo(() => {
    if (!candidateJobSearches) return []
    const start = (page - 1) * PAGE_SIZE
    return candidateJobSearches.slice(start, start + PAGE_SIZE)
  }, [candidateJobSearches, page])

  return (
    <>
      <Table
        className="w-full border-separate"
        tableClass="w-full rounded-2xl border border-silver"
      >
        <JobSearchHeading />
        <TableBody>
          {paginated.map((candidateJobSearch) => (
            <JobSearchRow
              key={`candidate-job-search-${candidateJobSearch.id}`}
              candidateJobSearch={candidateJobSearch}
            />
          ))}
        </TableBody>
      </Table>
      {total > PAGE_SIZE && (
        <Pagination
          page={page}
          pageSize={PAGE_SIZE}
          total={total}
          onPageChange={setPage}
        />
      )}
    </>
  )
}

export default JobSearches

const JobSearchRow = ({ candidateJobSearch, ...props }) => {
  const {
    what,
    where,
    company_name: companyName,
    radius,
    industry,
    career_level: careerLevel,
    created_from: createdFrom,
    created_at,
  } = candidateJobSearch || {}
  const formatTime = useFormatTime()
  return (
    <TableRow
      {...props}
      className="odd:bg-white even:bg-[#e2e2e2] even:bg-opacity-[29%]"
    >
      <TableCell>{what}</TableCell>
      <TableCell>{where}</TableCell>
      <TableCell>{companyName}</TableCell>
      <TableCell>{radius}</TableCell>
      <TableCell>{industry}</TableCell>
      <TableCell>{careerLevel}</TableCell>
      <TableCell>{createdFrom}</TableCell>
      <TableCell>{formatTime(created_at, 'short')}</TableCell>
    </TableRow>
  )
}

const JobSearchHeading = () => {
  const cells = [
    'What',
    'Where',
    'Company Name',
    'Radius',
    'Industry',
    'Career Level',
    'Created From',
    'Created At',
  ]
  return (
    <TableHeader className="h-6 bg-intoo-blue-medium">
      <TableRow className="text-lg text-white hover:bg-intoo-blue-medium">
        {cells.map((cell, index) => (
          <TableHead key={index} className="font-medium text-white">
            {cell}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  )
}
